import mustache from "mustache";
import { MonitoreoBrocaSemanaGroup } from "../../../../../modulos/monitoreo/broca/services/MonitoreoBrocaGetSemanaGroupListByFincaIdService";
import { _2d } from "../../../../../utils/numberUtils";
import { BaseSecondSidebarItemRender } from "../../../../base/sidebar/BaseSecondSidebarItemRender";
import template from "./monitoreoBrocaSemanaItemContentTemplate.html";

mustache.parse(template);

/** Item del sidebar de Monitoreo Broca: label con la semana ISO ("Semana 24") y
 *  contenido con, por cada lote monitoreado esa semana, un subtítulo con su
 *  nombre y una fila por métrica (Infestación / Mortalidad) con el badge de
 *  semáforo al final. Al seleccionarse notifica el grupo (el mapa pinta esos
 *  lotes). */
export class MonitoreoBrocaSemanaItemRender extends BaseSecondSidebarItemRender {
  /**
   * @param _semana   Grupo de monitoreos de la semana.
   * @param _onSemana Notifica el grupo al seleccionarse el item.
   */
  constructor(
    private readonly _semana: MonitoreoBrocaSemanaGroup,
    private readonly _onSemana: (semana: MonitoreoBrocaSemanaGroup) => void,
  ) {
    super();
  }

  /** "Semana N". */
  protected getLabel(): string {
    return `Semana ${this._semana.semana}`;
  }

  /** Sin título agregado: cada renglón ya muestra su propio lote + badges. */
  protected getTitle(): string {
    return "";
  }

  /** Por lote: subtítulo con el nombre + filas de Infestación y Mortalidad. */
  protected getItemContent(): string {
    return mustache.render(template, {
      registros: this._semana.registros.map((r) => ({
        loteNombre: r.loteNombre,
        infestacionReal: _2d(r.infestacionReal),
        infestacionRealColor: r.infestacionRealColor,
        mortalidad: _2d(r.mortalidad),
        mortalidadColor: r.mortalidadColor,
      })),
    });
  }

  /** Al seleccionarse: notifica el grupo (el mapa pinta esos lotes). */
  protected onSelected(): void {
    this._onSemana(this._semana);
  }
}
